var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137 66.5",
    style: {
      enableBackground: "new 0 0 137 66.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9B672;}\n\t.st1{fill:#EC6730;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.9,18.9l-3.8,11.5l4.2,14h-6.9l-2.7-10.9v10.9h-6.6V18.9h6.6v9.9l3-9.9C78.7,18.9,84.9,18.9,84.9,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.5,18.9V36c0,1.9-0.1,3.3-0.2,4.1s-0.5,1.6-1.1,2.4c-0.6,0.8-1.4,1.4-2.4,1.9c-1,0.4-2.2,0.6-3.6,0.6 c-1.5,0-2.9-0.2-4-0.8c-1.2-0.5-2-1.2-2.6-2c-0.6-0.8-0.9-1.7-1-2.6c-0.1-0.9-0.2-2.8-0.2-5.7V18.9h6.6v19.1 c0,1.1,0.1,1.8,0.2,2.1c0.1,0.3,0.4,0.5,0.7,0.5c0.4,0,0.7-0.2,0.8-0.5c0.1-0.3,0.2-1.2,0.2-2.4V18.9L101.5,18.9L101.5,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.1,18.9h4.7c3.1,0,5.2,0.1,6.4,0.4s2,0.9,2.7,1.9c0.7,1,1.1,2.6,1.1,4.7c0,2-0.2,3.3-0.7,4 s-1.5,1.1-2.9,1.2c1.3,0.3,2.2,0.8,2.6,1.3c0.4,0.6,0.7,1.1,0.8,1.5s0.2,1.7,0.2,3.8v6.7h-6.2V36c0-1.4-0.1-2.2-0.3-2.5 s-0.8-0.5-1.7-0.5v11.5h-6.6L104.1,18.9L104.1,18.9z M110.7,23.3V29c0.8,0,1.3-0.1,1.6-0.3c0.3-0.2,0.4-0.9,0.4-2v-1.4 c0-0.8-0.1-1.3-0.4-1.6S111.5,23.3,110.7,23.3L110.7,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.9,18.9l3.8,25.5h-6.8l-0.4-4.6h-2.4l-0.4,4.6H120l3.4-25.5L132.9,18.9L132.9,18.9z M129.4,35.3 c-0.3-2.9-0.7-6.5-1-10.7c-0.7,4.9-1.1,8.5-1.3,10.7H129.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.4,66.3c0-8.4-4.1-15.2-9-15.2v15.2H78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.4,66.3c0-8.4,4.1-15.2,9-15.2v15.2H78.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,51.1l2.3,15.2h-4L94,63.6h-1.4l-0.2,2.7h-4.1l2-15.2C90.3,51.1,96,51.1,96,51.1z M93.9,60.9 c-0.2-1.7-0.4-3.8-0.6-6.4c-0.4,2.9-0.7,5-0.8,6.4H93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.8,51.1v3h-2.3v12.2h-3.9V54.2h-2.3v-3H105.8L105.8,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.7,51.1v10.2c0,1.2,0,2-0.1,2.4s-0.3,0.9-0.7,1.4c-0.4,0.5-0.9,0.9-1.5,1.1c-0.6,0.2-1.3,0.4-2.1,0.4 c-0.9,0-1.7-0.2-2.4-0.4c-0.7-0.3-1.2-0.7-1.6-1.2c-0.3-0.5-0.6-1-0.6-1.5s-0.1-1.7-0.1-3.4v-9h3.9v11.4c0,0.7,0,1.1,0.1,1.3 s0.2,0.3,0.4,0.3c0.2,0,0.4-0.1,0.5-0.3s0.1-0.7,0.1-1.4V51.2L115.7,51.1L115.7,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.2,51.1h2.8c1.9,0,3.1,0.1,3.8,0.2c0.7,0.1,1.2,0.5,1.6,1.1c0.4,0.6,0.6,1.5,0.6,2.8c0,1.2-0.1,2-0.4,2.4 c-0.3,0.4-0.9,0.7-1.7,0.7c0.8,0.2,1.3,0.4,1.6,0.8s0.4,0.6,0.5,0.9c0.1,0.3,0.1,1,0.1,2.2v4h-3.7v-5.1c0-0.8-0.1-1.3-0.2-1.5 s-0.5-0.3-1-0.3v6.8h-3.9C117.2,66.3,117.2,51.1,117.2,51.1z M121.2,53.7v3.4c0.4,0,0.8-0.1,0.9-0.2c0.2-0.1,0.3-0.5,0.3-1.2v-0.8 c0-0.5-0.1-0.8-0.3-0.9S121.6,53.7,121.2,53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.4,51.1l2.3,15.2h-4l-0.2-2.7H131l-0.2,2.7h-4.1l2-15.2C128.7,51.1,134.4,51.1,134.4,51.1z M132.3,60.9 c-0.2-1.7-0.4-3.8-0.6-6.4c-0.4,2.9-0.7,5-0.8,6.4H132.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.2,42.8c4.9,0,8.8-4,8.8-8.8h-8.8V42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.1,51.6c0-4.9-3.9-8.8-8.8-8.8v8.8H58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,66.6h47.7V18.9C21.4,18.9,0,40.3,0,66.6z M34.2,34v-8.8c4.9,0,8.8,4,8.8,8.8H34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.1,17.7c0-4.9-4-8.8-8.8-8.8v8.8H30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.7,17.7c0-9.7-7.9-17.6-17.6-17.6v17.6H47.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo_text.05be9e8d1ff321a24ca6547a80312879.svg";
export { ForwardRef as ReactComponent };